import React from 'react';

import Link from 'gatsby-link';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    display: 'inline-flex',
    minWidth: 50,
    height: 20,
    borderRadius: 25,
    border: '1px solid #b8b8b8',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Raleway',
    fontSize: 10,
    color: '#b8b8b8',
    textDecoration: 'none',
    marginRight: 5,
    padding: '0 8px',
  },
});

const Tag = ({ classes, name, slug }) => (
  <Link to={`/blog/tag/${slug}`} className={classes.root}>
    {name}
  </Link>
);

export default withStyles(styles)(Tag);
